export var ContributionVEFStatus;
(function (ContributionVEFStatus) {
    ContributionVEFStatus["REQUESTED"] = "REQUESTED";
    ContributionVEFStatus["CHECKED"] = "CHECKED";
    ContributionVEFStatus["VALIDATED"] = "VALIDATED";
    ContributionVEFStatus["CLOSED"] = "CLOSED";
})(ContributionVEFStatus || (ContributionVEFStatus = {}));
//====================================================
// Contributions VEF actions enum
//====================================================
export const ContributionsVEFActions = {
    CHECK_VALIDATE: 'check-validate',
    CHECK: 'check',
    VALIDATE: 'validate',
    FAST_VALIDATE: 'fast-validate',
    ACCESS: 'access',
};
//# sourceMappingURL=contributions-vef.js.map